import { useEffect, useState } from 'react';
import { useGTMDataLayer } from './useGTMDataLayer';
import { EventPayload } from '../../../../types/GTM/EventPayload';

export const useSendGTMEventOnce = (
  event: EventPayload | undefined,
  deps: any[],
  onComplete?: () => void,
  onError?: (error: any) => void,
): void => {
  const [tagIsSent, setTagIsSent] = useState(false);
  const dataLayer = useGTMDataLayer();

  useEffect(() => {
    if (dataLayer && !tagIsSent && event) {
      try {
        dataLayer.push(event);
        setTagIsSent(true);
        if (onComplete) onComplete();
      } catch (error) {
        if (onError) onError(error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, dataLayer, tagIsSent, ...(deps || [])]);
};

export const createEventPayload = (event: EventPayload): EventPayload => {
  if (!event.ecommerce) {
    return event;
  }

  const { items, ...restEcommerce } = event.ecommerce;
  const mappedItems =
    items?.map((item) => ({
      ...item,
      item_brand: item.item_brand ?? 'NAF',
      item_category: item.item_category ?? 'NAF',
      item_list_id: item.item_list_id ?? 'Produktside',
      item_list_name: item.item_list_name ?? 'Produkter',
    })) || [];

  return {
    ...event,
    ecommerce: {
      ...restEcommerce,
      currency: event.ecommerce.currency ?? 'NOK',
      affiliation: event.ecommerce.affiliation ?? 'Naf.no',
      items: mappedItems,
    },
  };
};

export const createPromotionEventPayload = (event: EventPayload): EventPayload => {
  if (!event.ecommerce) {
    return event;
  }

  const { items, ...restEcommerce } = event.ecommerce;
  const mappedItems =
    items?.map((item) => ({
      ...item,
    })) || [];

  return {
    ...event,
    ecommerce: {
      ...restEcommerce,
      items: mappedItems,
    },
  };
};
